import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import * as actions from './../actions/actions';

// selectors
import { getFocusedWidget, getWidgetsTypesOnPage } from '../selectors/selectors';

// tools
import General from './../components/Tools/General';
import Preferences from './../components/Tools/Preferences';

// tools ui
import EditButtons from './../components/Tools/UI/EditButtons';

// widget tools
import Text from './../components/Tools/Widgets/Text/Text';
import ChoiceTools from './../components/Tools/Widgets/Choice/ChoiceTools';
import Input from './../components/Tools/Widgets/Input/Input';
import Range from './../components/Tools/Widgets/Range/Range';

// icons
import { icon } from './../icons/icons';

class Tools extends React.Component {
    constructor(props) {
        super(props);
        this.showPreferences = this.showPreferences.bind(this);
    }

    showPreferences() {
        this.props.actions.setWidgetTools('prefs', null);
    }

    render() {
        let toolContent;
        const { app, tools, widget, widgetsTypesOnPage, widgetsTemplates, template, templates, actions } = this.props;
        const general = <General actions={actions} widgetsTemplates={widgetsTemplates} widgetsTypesOnPage={widgetsTypesOnPage} />;
        const prefs = <Preferences actions={actions} app={app} template={template} templates={templates} />;

        if (!widget) {
            if (tools.kind === 'prefs') {
                toolContent = prefs;
            } else {
                toolContent = general;
            }
        } else {
            switch (tools.kind) {
            case 'general':
                toolContent = general;
                break;
            case 'prefs':
                toolContent = prefs;
                break;
            case 'text':
                toolContent = <Text widget={widget} actions={actions} />;
                break;
            case 'choice':
                toolContent = <ChoiceTools widget={widget} actions={actions} />;
                break;
            case 'input':
                toolContent = <Input widget={widget} actions={actions} />;
                break;
            case 'range':
                toolContent = <Range widget={widget} actions={actions} />;
                break;
            default:
                toolContent = <div className="qr-notool">NO TOOL FOUND</div>;
            }
        }

        return (
            <div className="tools -opened">
                <div className="tools__trigger"><span>Questions manager</span></div>
                {(tools.kind !== 'prefs') ? <span className="icon prefs-icon" title="Preferences" onClick={this.showPreferences}>{icon.gear()}</span> : null}
                {toolContent}
                <EditButtons app={app} actions={actions} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    tools: state.tools,
    widget: getFocusedWidget(state),
    widgetsTypesOnPage: getWidgetsTypesOnPage(state),
    widgetsTemplates: state.widgets.template,
    template: state.templates[state.app.template],
    templates: state.templates,
    activeWidget: state.widgets.activeWidget,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Tools.propTypes = {
    app: PropTypes.object.isRequired,
    tools: PropTypes.object.isRequired,
    template: PropTypes.object.isRequired,
    templates: PropTypes.object.isRequired,
    widget: PropTypes.object,
    widgetsTypesOnPage: PropTypes.array.isRequired,
    widgetsTemplates: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tools);



// WEBPACK FOOTER //
// ./src/_app/quick_response/containers/Tools.jsx